
import { useState } from 'react'
import { FaPencilAlt, FaTrashAlt } from 'react-icons/fa'
import { FiCheck } from 'react-icons/fi'

import Modal from '../../../shared/modal/Modal'
import ConfirmDeleteModal from '../../../shared/components/ConfirmDeleteModal/ConfirmDeleteModal'
import api from '../../../utils/api'

import EditAdditive from '../EditAdditive'
import NumberToMoney from '../../../shared/functions/NumberToMoney'

/* Hooks */
import useFlashMessage from '../../../hooks/useFlashMessage'


function ListAdditiveRow({ dataArray, myPermissionView, myPermissionEdit, myPermissionDelete, myPermissionViewCost, handleOnSuccess, selectItem, handleOnSelectItem, selectedData }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    /* ------------------- Modal useState ----------------------*/

    const [modalEditAdditive, setModalEditAdditive] = useState(false)
    const [additiveId, setAdditiveId] = useState("")
    const [modalDeleteItem, setModalDeleteItem] = useState(false)
    const [additiveName, setAdditiveName] = useState("")
    const [selectedItens, setSelectedItens] = useState(selectedData || [])

    async function deleteAdditive(id) {
        let msgType = 'success'
        const data = await api.delete(`/additive/delete/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            if (response) {
                handleOnSuccess()
                setModalDeleteItem(false)
            }

            return response.data
        }).catch((err) => {

            msgType = 'error'
            return err.response.data
        })

        setFlashMessage(data.message, msgType)
    }

    const isSelected = (item) => !!selectedItens.find((i) => i._id === item._id)

    const select = (item) => {
        const next = isSelected(item)
            ? selectedItens.filter((i) => i._id !== item._id)
            : [...selectedItens, item]
        setSelectedItens(next)
        handleOnSelectItem(next)
    }

    /* ------------------------ cards ------------------------------ */
    const listArray = () => {
        if (myPermissionView && dataArray && dataArray.length > 0) {
            return dataArray.map((item) => (
                selectItem ? (
                    <div key={item._id} className={`pg-item pg-item-selectable ${isSelected(item) ? 'pg-item-selected' : ''}`} onClick={() => select(item)}>
                        <div className='pg-item-main'>
                            <div className='pg-item-header'>
                                <span className='pg-item-name'>{item.name}</span>
                                <span className='pg-item-name'>R$ {NumberToMoney(item.price)}</span>
                            </div>
                            {myPermissionViewCost && (
                                <span className='additive-margin'>
                                    Custo: R$ {item.cost ? NumberToMoney(item.cost) : '—'}
                                    {item.cost && ` · Lucro: R$ ${NumberToMoney(parseFloat(item.price) - parseFloat(item.cost))}`}
                                </span>
                            )}
                        </div>
                        <div className={`pg-item-checkbox ${isSelected(item) ? 'pg-item-checkbox-checked' : ''}`}>
                            <FiCheck size={14} />
                        </div>
                    </div>
                ) : (
                    <div key={item._id} className='pg-item'>
                        <div className='pg-item-main'>
                            <div className='pg-item-header'>
                                <span className='pg-item-name'>{item.name}</span>
                                <span className='pg-item-name'>R$ {NumberToMoney(item.price)}</span>
                            </div>
                            {myPermissionViewCost && (
                                <span className='additive-margin'>
                                    Custo: R$ {item.cost ? NumberToMoney(item.cost) : '—'}
                                    {item.cost && ` · Lucro: R$ ${NumberToMoney(parseFloat(item.price) - parseFloat(item.cost))}`}
                                </span>
                            )}
                        </div>

                        <div className='shd-row-box-item-action'>
                            {myPermissionEdit &&
                                <FaPencilAlt className='shd-icon-row-edit' title='Editar' onClick={() => { setAdditiveId(item._id); setModalEditAdditive(true) }} />
                            }
                            {myPermissionDelete &&
                                <FaTrashAlt className='shd-icon-row-trash' title='Apagar' onClick={() => { setModalDeleteItem(true); setAdditiveId(item._id); setAdditiveName(item.name) }} />
                            }
                        </div>
                    </div>
                )
            ))
        }
    }

    return (
        <div>
            {listArray()}

            {!selectItem && (
                <>
                    <Modal
                        modalStatus={modalEditAdditive}
                        changeStatus={setModalEditAdditive}
                        w={82}
                        content={
                            <EditAdditive id={additiveId} handleOnSuccess={() => { setModalEditAdditive(false); handleOnSuccess() }} btCancelAction={() => setModalEditAdditive(false)} />
                        }
                    />

                    <ConfirmDeleteModal
                        modalStatus={modalDeleteItem}
                        changeStatus={setModalDeleteItem}
                        onConfirm={() => deleteAdditive(additiveId)}
                        message="Deseja realmente excluir esse aditivo?"
                        itemName={additiveName}
                    />
                </>
            )}

        </div>
    )
}

export default ListAdditiveRow
